import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBAdditionalPopupIsOpen } from 'pages/Internet/store/selectors/servicesSelectors';
import { closeServiceAdditionalPopup } from 'pages/Internet/store/actions/servicesActions';

import { PopupContentWrapper } from '../../components';
import {
  ConnectionConnected, ErrorConnected, LoadingConnected,
  NoMoneyConnected, PromisedConnected, SuccessConnected,
} from './connected';

const ConnectionPopup = ({ onClose }) => (
  <Popup opened onClose={onClose}>
    <PopupContentWrapper>
      <ConnectionConnected />
      <SuccessConnected />
      <PromisedConnected />
      <NoMoneyConnected />

      <LoadingConnected />
      <ErrorConnected />
    </PopupContentWrapper>
  </Popup>
);

ConnectionPopup.propTypes = {
  onClose: PropTypes.func,
};

export const AdditionalServicesPopup = compose(
  connect((state) => ({
    shouldRender: !!getFTTBAdditionalPopupIsOpen(state),
  }), {
    onClose: closeServiceAdditionalPopup,
  }),
  withRenderFlag,
)(ConnectionPopup);
